import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { PlanMethodologyNote } from "@/components/plan-methodology/plan-methodology-note";
import { PlanRecommendationNote } from "@/components/plan-methodology/plan-recommendation-note";

export default function PlanMethodologyPage() {
  return (
    <PageContainer className="px-4 app-bar-bottom-padding overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-4">
        <PageTitleComponent
          title="How we calculate your plan"
          description="The formulas and sources behind your calories, macros, and recommendations."
        />

        <PlanMethodologyNote showRecommendationsNote />
        <PlanRecommendationNote />
      </div>
    </PageContainer>
  );
}
